"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MessageStatus = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _gridStyled = require("grid-styled");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _themeMapper = require("@gravity/theme-mapper");
var _jsxFileName = "/codebuild/output/src4284278962/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Message/lib/Message.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_x1lpmcgtr() {
  var path = "/codebuild/output/src4284278962/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Message/lib/Message.js";
  var hash = "7b366625a32c0d7ae8b3fc5ad6e3ea2b2c818391";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4284278962/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Message/lib/Message.js",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 22
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 26,
          column: 18
        },
        end: {
          line: 26,
          column: 20
        }
      },
      "2": {
        start: {
          line: 27,
          column: 0
        },
        end: {
          line: 27,
          column: 63
        }
      },
      "3": {
        start: {
          line: 28,
          column: 0
        },
        end: {
          line: 28,
          column: 49
        }
      },
      "4": {
        start: {
          line: 29,
          column: 0
        },
        end: {
          line: 29,
          column: 45
        }
      },
      "5": {
        start: {
          line: 30,
          column: 0
        },
        end: {
          line: 30,
          column: 39
        }
      },
      "6": {
        start: {
          line: 31,
          column: 0
        },
        end: {
          line: 31,
          column: 45
        }
      },
      "7": {
        start: {
          line: 33,
          column: 28
        },
        end: {
          line: 33,
          column: 30
        }
      },
      "8": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 34,
          column: 73
        }
      },
      "9": {
        start: {
          line: 35,
          column: 0
        },
        end: {
          line: 35,
          column: 64
        }
      },
      "10": {
        start: {
          line: 36,
          column: 0
        },
        end: {
          line: 36,
          column: 66
        }
      },
      "11": {
        start: {
          line: 37,
          column: 0
        },
        end: {
          line: 37,
          column: 62
        }
      },
      "12": {
        start: {
          line: 38,
          column: 0
        },
        end: {
          line: 38,
          column: 68
        }
      },
      "13": {
        start: {
          line: 43,
          column: 19
        },
        end: {
          line: 43,
          column: 21
        }
      },
      "14": {
        start: {
          line: 44,
          column: 0
        },
        end: {
          line: 44,
          column: 45
        }
      },
      "15": {
        start: {
          line: 45,
          column: 0
        },
        end: {
          line: 45,
          column: 45
        }
      },
      "16": {
        start: {
          line: 46,
          column: 0
        },
        end: {
          line: 46,
          column: 46
        }
      },
      "17": {
        start: {
          line: 47,
          column: 0
        },
        end: {
          line: 47,
          column: 40
        }
      },
      "18": {
        start: {
          line: 48,
          column: 0
        },
        end: {
          line: 48,
          column: 47
        }
      },
      "19": {
        start: {
          line: 50,
          column: 29
        },
        end: {
          line: 50,
          column: 31
        }
      },
      "20": {
        start: {
          line: 51,
          column: 0
        },
        end: {
          line: 51,
          column: 75
        }
      },
      "21": {
        start: {
          line: 52,
          column: 0
        },
        end: {
          line: 52,
          column: 75
        }
      },
      "22": {
        start: {
          line: 53,
          column: 0
        },
        end: {
          line: 53,
          column: 79
        }
      },
      "23": {
        start: {
          line: 54,
          column: 0
        },
        end: {
          line: 54,
          column: 73
        }
      },
      "24": {
        start: {
          line: 55,
          column: 0
        },
        end: {
          line: 55,
          column: 79
        }
      },
      "25": {
        start: {
          line: 57,
          column: 16
        },
        end: {
          line: 82,
          column: 2
        }
      },
      "26": {
        start: {
          line: 66,
          column: 22
        },
        end: {
          line: 66,
          column: 33
        }
      },
      "27": {
        start: {
          line: 68,
          column: 29
        },
        end: {
          line: 68,
          column: 40
        }
      },
      "28": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 33
        }
      },
      "29": {
        start: {
          line: 79,
          column: 29
        },
        end: {
          line: 79,
          column: 40
        }
      },
      "30": {
        start: {
          line: 84,
          column: 20
        },
        end: {
          line: 86,
          column: 4
        }
      },
      "31": {
        start: {
          line: 88,
          column: 23
        },
        end: {
          line: 99,
          column: 2
        }
      },
      "32": {
        start: {
          line: 106,
          column: 67
        },
        end: {
          line: 106,
          column: 77
        }
      },
      "33": {
        start: {
          line: 107,
          column: 28
        },
        end: {
          line: 109,
          column: 36
        }
      },
      "34": {
        start: {
          line: 110,
          column: 27
        },
        end: {
          line: 110,
          column: 121
        }
      },
      "35": {
        start: {
          line: 111,
          column: 18
        },
        end: {
          line: 111,
          column: 75
        }
      },
      "36": {
        start: {
          line: 112,
          column: 21
        },
        end: {
          line: 112,
          column: 53
        }
      },
      "37": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 124,
          column: 6
        }
      },
      "38": {
        start: {
          line: 128,
          column: 0
        },
        end: {
          line: 147,
          column: 2
        }
      },
      "39": {
        start: {
          line: 148,
          column: 0
        },
        end: {
          line: 156,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 66,
            column: 13
          },
          end: {
            line: 66,
            column: 14
          }
        },
        loc: {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 66,
            column: 33
          }
        },
        line: 66
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 68,
            column: 20
          },
          end: {
            line: 68,
            column: 21
          }
        },
        loc: {
          start: {
            line: 68,
            column: 29
          },
          end: {
            line: 68,
            column: 40
          }
        },
        line: 68
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 77,
            column: 13
          },
          end: {
            line: 77,
            column: 14
          }
        },
        loc: {
          start: {
            line: 77,
            column: 22
          },
          end: {
            line: 77,
            column: 33
          }
        },
        line: 77
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 79,
            column: 20
          },
          end: {
            line: 79,
            column: 21
          }
        },
        loc: {
          start: {
            line: 79,
            column: 29
          },
          end: {
            line: 79,
            column: 40
          }
        },
        line: 79
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        loc: {
          start: {
            line: 105,
            column: 11
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 105
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 107,
            column: 28
          },
          end: {
            line: 109,
            column: 36
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 108,
            column: 8
          },
          end: {
            line: 108,
            column: 50
          }
        }, {
          start: {
            line: 109,
            column: 8
          },
          end: {
            line: 109,
            column: 36
          }
        }],
        line: 107
      },
      "1": {
        loc: {
          start: {
            line: 110,
            column: 27
          },
          end: {
            line: 110,
            column: 121
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 110,
            column: 74
          },
          end: {
            line: 110,
            column: 91
          }
        }, {
          start: {
            line: 110,
            column: 94
          },
          end: {
            line: 110,
            column: 121
          }
        }],
        line: 110
      },
      "2": {
        loc: {
          start: {
            line: 111,
            column: 18
          },
          end: {
            line: 111,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 27
          },
          end: {
            line: 111,
            column: 42
          }
        }, {
          start: {
            line: 111,
            column: 45
          },
          end: {
            line: 111,
            column: 75
          }
        }],
        line: 111
      },
      "3": {
        loc: {
          start: {
            line: 112,
            column: 21
          },
          end: {
            line: 112,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 30
          },
          end: {
            line: 112,
            column: 44
          }
        }, {
          start: {
            line: 112,
            column: 47
          },
          end: {
            line: 112,
            column: 53
          }
        }],
        line: 112
      },
      "4": {
        loc: {
          start: {
            line: 116,
            column: 9
          },
          end: {
            line: 121,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 9
          },
          end: {
            line: 116,
            column: 17
          }
        }, {
          start: {
            line: 117,
            column: 10
          },
          end: {
            line: 117,
            column: 16
          }
        }, {
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 120,
            column: 26
          }
        }],
        line: 116
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "7b366625a32c0d7ae8b3fc5ad6e3ea2b2c818391"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_x1lpmcgtr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_x1lpmcgtr();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Different message status that can be displayed
 */
var MessageStatus = exports.MessageStatus = (cov_x1lpmcgtr().s[0]++, {
  FATAL: 'FATAL',
  ERROR: 'ERROR',
  WARNING: 'WARNING',
  INFO: 'INFO',
  SUCCESS: 'SUCCESS'
});

/**
 * Icon name depending on the message status
 */
var ICON_NAME = (cov_x1lpmcgtr().s[1]++, {});
cov_x1lpmcgtr().s[2]++;
ICON_NAME[MessageStatus.FATAL] = 'sentiment-very-dissatisfied';
cov_x1lpmcgtr().s[3]++;
ICON_NAME[MessageStatus.ERROR] = 'error-outline';
cov_x1lpmcgtr().s[4]++;
ICON_NAME[MessageStatus.WARNING] = 'warning';
cov_x1lpmcgtr().s[5]++;
ICON_NAME[MessageStatus.INFO] = 'info';
cov_x1lpmcgtr().s[6]++;
ICON_NAME[MessageStatus.SUCCESS] = 'success';
var ICON_NAME_EVOLUTION = (cov_x1lpmcgtr().s[7]++, {});
cov_x1lpmcgtr().s[8]++;
ICON_NAME_EVOLUTION[MessageStatus.FATAL] = 'sentiment-very-dissatisfied';
cov_x1lpmcgtr().s[9]++;
ICON_NAME_EVOLUTION[MessageStatus.ERROR] = 'riErrorWarningLine';
cov_x1lpmcgtr().s[10]++;
ICON_NAME_EVOLUTION[MessageStatus.WARNING] = 'riErrorWarningLine';
cov_x1lpmcgtr().s[11]++;
ICON_NAME_EVOLUTION[MessageStatus.INFO] = 'riInformationLine';
cov_x1lpmcgtr().s[12]++;
ICON_NAME_EVOLUTION[MessageStatus.SUCCESS] = 'riCheckBoxCircleLine';

/**
 * Icon color depending on the message status, this will be taken from our styling constants.
 */
var ICON_COLOR = (cov_x1lpmcgtr().s[13]++, {});
cov_x1lpmcgtr().s[14]++;
ICON_COLOR[MessageStatus.FATAL] = 'negative';
cov_x1lpmcgtr().s[15]++;
ICON_COLOR[MessageStatus.ERROR] = 'negative';
cov_x1lpmcgtr().s[16]++;
ICON_COLOR[MessageStatus.WARNING] = 'warning';
cov_x1lpmcgtr().s[17]++;
ICON_COLOR[MessageStatus.INFO] = 'info';
cov_x1lpmcgtr().s[18]++;
ICON_COLOR[MessageStatus.SUCCESS] = 'positive';
var ICON_COLOR_EVOLUTION = (cov_x1lpmcgtr().s[19]++, {});
cov_x1lpmcgtr().s[20]++;
ICON_COLOR_EVOLUTION[MessageStatus.FATAL] = 'theme.messageErrorTitleColor';
cov_x1lpmcgtr().s[21]++;
ICON_COLOR_EVOLUTION[MessageStatus.ERROR] = 'theme.messageErrorTitleColor';
cov_x1lpmcgtr().s[22]++;
ICON_COLOR_EVOLUTION[MessageStatus.WARNING] = 'theme.messageWarningTitleColor';
cov_x1lpmcgtr().s[23]++;
ICON_COLOR_EVOLUTION[MessageStatus.INFO] = 'theme.messageInfoTitleColor';
cov_x1lpmcgtr().s[24]++;
ICON_COLOR_EVOLUTION[MessageStatus.SUCCESS] = 'theme.messageSuccessTitleColor';
var Wrapper = (cov_x1lpmcgtr().s[25]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'g-Message'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    align-items: center;\n    position: relative;\n    padding: 10px;\n    text-align: left;\n    margin: 0 auto;\n    color: ", ";\n    word-break: break-word;\n    border-color: ", ";\n    border: 1px solid;\n  "])), function (props) {
  cov_x1lpmcgtr().f[0]++;
  cov_x1lpmcgtr().s[26]++;
  return props.color;
}, function (props) {
  cov_x1lpmcgtr().f[1]++;
  cov_x1lpmcgtr().s[27]++;
  return props.color;
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    align-items: center;\n    position: relative;\n    padding: 10px;\n    text-align: left;\n    margin: 0 auto;\n    color: ", ";\n    word-break: break-word;\n    border-color: ", ";\n    border: 1px solid;\n  "])), function (props) {
  cov_x1lpmcgtr().f[2]++;
  cov_x1lpmcgtr().s[28]++;
  return props.color;
}, function (props) {
  cov_x1lpmcgtr().f[3]++;
  cov_x1lpmcgtr().s[29]++;
  return props.color;
}))));
var IconWrapper = (cov_x1lpmcgtr().s[30]++, _styledComponents.default.div.attrs({
  className: 'g-Message-icon'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)([""]))));
var ContentWrapper = (cov_x1lpmcgtr().s[31]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'g-Message-content'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n    margin-left: 1rem;\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    margin-left: 12px;\n    width: 100%;\n    font-size: ", ";\n  "])), _themeMapper.evolutionTheme.typography.caption1.fontSize))));

/**
 * This component will return an icon and message with a certain color depending of the status passed as parameter.
 */
var Message = /*#__PURE__*/function (_PureComponent) {
  function Message() {
    (0, _classCallCheck2.default)(this, Message);
    return _callSuper(this, Message, arguments);
  }
  (0, _inherits2.default)(Message, _PureComponent);
  return (0, _createClass2.default)(Message, [{
    key: "render",
    value: function render() {
      cov_x1lpmcgtr().f[4]++;
      var _ref = (cov_x1lpmcgtr().s[32]++, this.props),
        status = _ref.status,
        showIcon = _ref.showIcon,
        children = _ref.children,
        iconSize = _ref.iconSize,
        currentTheme = _ref.currentTheme;
      var colorThemeValue = (cov_x1lpmcgtr().s[33]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM ? (cov_x1lpmcgtr().b[0][0]++, _stylingConstants.default.color[ICON_COLOR[status]]) : (cov_x1lpmcgtr().b[0][1]++, ICON_COLOR_EVOLUTION[status]));
      var iconThemeValue = (cov_x1lpmcgtr().s[34]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM ? (cov_x1lpmcgtr().b[1][0]++, ICON_NAME[status]) : (cov_x1lpmcgtr().b[1][1]++, ICON_NAME_EVOLUTION[status]));
      var color = (cov_x1lpmcgtr().s[35]++, status ? (cov_x1lpmcgtr().b[2][0]++, colorThemeValue) : (cov_x1lpmcgtr().b[2][1]++, _stylingConstants.default.color["info"]));
      var iconName = (cov_x1lpmcgtr().s[36]++, status ? (cov_x1lpmcgtr().b[3][0]++, iconThemeValue) : (cov_x1lpmcgtr().b[3][1]++, "info"));
      cov_x1lpmcgtr().s[37]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        color: color,
        className: "g-Message--".concat(status, " ").concat(this.props.className),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115,
          columnNumber: 7
        }
      }, (cov_x1lpmcgtr().b[4][0]++, showIcon) && (cov_x1lpmcgtr().b[4][1]++, status) && (cov_x1lpmcgtr().b[4][2]++, /*#__PURE__*/_react.default.createElement(IconWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: iconSize,
        iconColor: color,
        iconName: iconName,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 119,
          columnNumber: 15
        }
      }))), /*#__PURE__*/_react.default.createElement(ContentWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122,
          columnNumber: 9
        }
      }, children));
    }
  }]);
}(_react.PureComponent);
cov_x1lpmcgtr().s[38]++;
Message.propTypes = {
  /**
   * Status of the message we want to show. At the top of the file we have the different options.
   */
  status: _propTypes.default.string,
  /**
   * Boolean to indicate if we want to display (default) the icon or not (false)
   */
  showIcon: _propTypes.default.bool,
  /** May contains a number or one of small, default, large, xlarge */
  iconSize: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  /**
   * Node or string with the component/message will be displayed
   */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  className: _propTypes.default.string,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_x1lpmcgtr().s[39]++;
Message.defaultProps = {
  status: 'info',
  showIcon: true,
  iconSize: 30,
  className: '',
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {},
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(Message));